import { gql } from '@apollo/client';

/**
 * The Follow-ups screen (card 22, on card 16's `crmCalls`): ilbp-backend
 * docs/CARD_22_FOLLOW_UPS.md. Fields are written out, not shared as fragments:
 * the tests run without __typename (CLAUDE.md).
 */

/**
 * One page of open follow-ups, the earliest first. `withCounts` asks, once per
 * filter, who set them (`byCaller`) and how many each view holds (`due`,
 * `upcoming`): the counts on the two tabs, this view's being its total. Both
 * count under "Set by", so the tabs say what switching would list. A page is reached by
 * `after` (next) where its cursor is known, by `skip` otherwise.
 *
 * `contact.phones` is what "Wrong number" needs to mark the number dialled bad
 * (dialledNumber), as on the person's page.
 */
export const CRM_FOLLOW_UPS = gql`
  query CrmFollowUps(
    $filter: CrmCallFilter
    $take: Int
    $after: String
    $skip: Int
    $withCounts: Boolean!
    $dueFilter: CrmCallFilter
    $upcomingFilter: CrmCallFilter
  ) {
    crmCalls(filter: $filter, order: FOLLOW_UP, take: $take, after: $after, skip: $skip) {
      hasNextPage
      endCursor
      byCaller @include(if: $withCounts) {
        adminId
        authorContactId
        isYou
        count
        admin {
          id
          firstName
          lastName
        }
        author {
          id
          fullName
        }
      }
      items {
        id
        contactId
        adminId
        authorContactId
        source
        direction
        method
        outcome
        notes
        durationSec
        supportLevel
        occurredAt
        followUpAt
        followUpDoneAt
        followUpOpen
        followUpDue
        setDoNotCall
        recordingUrl
        editable
        createdAt
        updatedAt
        contact {
          id
          fullName
          primaryEmail
          primaryPhone
          doNotCall
          doNotContact
          canCall
          mergedIntoId
          phones {
            id
            e164
            isPrimary
            isBad
          }
        }
        admin {
          id
          firstName
          lastName
        }
        author {
          id
          fullName
        }
        followUpDoneBy {
          id
          firstName
          lastName
        }
      }
    }
    due: crmCalls(filter: $dueFilter, order: FOLLOW_UP, take: 1) @include(if: $withCounts) {
      total
    }
    upcoming: crmCalls(filter: $upcomingFilter, order: FOLLOW_UP, take: 1) @include(if: $withCounts) {
      total
    }
  }
`;
